// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__IQcEE","logoImage":"Header_logoImage__Htbe0"};